module.exports = __webpack_public_path__ + "img/498.1cb492b0.jpg";